module.exports = __webpack_public_path__ + "img/image (18).69795de2.webp";